import { Component } from '@angular/core';

@Component({
  selector: 'lib-group',
  imports: [],
  templateUrl: './group.html',
})
export class GroupIcon {}
